import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { RateLimitService } from '../../services/rate-limit.service';

interface IViewRateLimitProfileContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-view-rate-limit-profile',
  templateUrl: './viewRateLimitProfile.component.html',
  styleUrls: ['./viewRateLimitProfile.component.scss'],
})
export class ViewRateLimitProfileComponent implements OnInit {
  rateLimitProfilesLoading = false;
  success!: string;
  error!: string;
  rateLimitProfile: any;

  constructor(
    public modal: SuiModal<IViewRateLimitProfileContext, any, any>,
    private rateLimitSvc: RateLimitService
  ) {}

  ngOnInit(): void {
    this.rateLimitProfilesLoading = true;
    this.rateLimitSvc
      .getProfiles(this.modal.context.data.user.appUserId)
      .subscribe(
        (res: any) => {
          for (let i = 0; i < res.ratelimitProfiles.length; i++) {
            if (
              res.ratelimitProfiles[i].rateLimitProfileId ===
              this.modal.context.data.metadata.rateLimitProfileId
            ) {
              this.rateLimitProfile = res.ratelimitProfiles[i];
              break;
            }
          }
          this.rateLimitProfilesLoading = false;
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;
          this.rateLimitProfilesLoading = false;
        }
      );
  }
}

export class ViewRateLimitProfileModal extends ComponentModalConfig<
  IViewRateLimitProfileContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(ViewRateLimitProfileComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
